
<div class="container-fluid py-4">
  <div class="row mb-4">
    <div class="col">
      <h5 class="mb-3">Organizations (non-OData paging)</h5>
          <kendo-grid
            [data]="gridService | async"
            [pageable]="{
              buttonCount: 5,
              info: true,
              type: 'numeric',
              pageSizes: [10, 25, 50, 100]
            }"
            [pageSize]="gridService.state.take"
            [skip]="gridService.state.skip"
            [(filter)]="gridService.state.filter"
            [loading]="gridService.loading"
            (dataStateChange)="gridService.onStateChange($event)"
            [sort]="this.gridService.state.sort"
            [sortable]="true"
          >
            <ng-template kendoGridLoadingTemplate>
              <div class="d-flex justify-content-center p-4">
                <div class="spinner-border text-primary" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </div>
            </ng-template>
          </kendo-grid>
    </div>
  </div>
</div>


